import us from './defines';
import { translate } from 'shared/services/I18nService';

/*
 This file creates the toolbar for uscope, creates the settings panel, and other panels and handles their events.

 The "main" toolbar contains the feature access buttons and settings.  It is positioned below
 the selected image's toolbar.
 */

const i18Namespace = 'uScope.others.toolbar';

export function Toolbar (uScope) {
  const $t = translate.scope(i18Namespace);

  var self = this;
  var jtoolbar;

  // ............................................ position() public
  //    position - This function positions the main toolbar on the selected image.
  this.position = function (crOffset) {
    if (crOffset == undefined) { jtoolbar.css({'left': '2px', 'top': '2px'}); } else { jtoolbar.css({'left': crOffset.x + 'px', 'top': (crOffset.y + crOffset.h) + 'px'}); }
  };
  // ............................................ bindEvents_() local
  // bindEvents_ - This function adds the autopan event handlers.
  //
  //    Note that an exception is made here and the namespace is not an image's namespace.

  var bindEvents_ = function () {
    var namespace = '.autopan';

    $(us.idHashROOT).on('click' + namespace, '.' + us.idTBMULTIVIEW + '-4' + // multi image arrangement button
            ',.' + us.idTBMULTIVIEW + '-v' + ',.' + us.idTBMULTIVIEW + '-h', function (e) {
      if (uScope.getImageCount() > 1) {
        uScope.imageArrange(true);
      }
      return false;
    });
  };
    // ............................................ init_() local
    //    init_ = This function creates the toolbar, sizes it and adds its event handlers.
  var init_ = function () {
    jtoolbar = $(us.idHashROOT).find('#' + us.idTOPTOOLBARV); // if the toolbar already exists, remove it
    if (jtoolbar.length) { jtoolbar.remove(); }
    jtoolbar = $('<div/>', { // build the toolbar div tag
      'id': us.idTOPTOOLBARV,
      'class': us.clsSUPEROVERLAY + ' ' + us.clsTRANSPARENT,
      'title': $t('toggle-autopan')
    });

    // multi-image arangement
    jtoolbar.append($('<a/>', {
      'id': us.idTBMULTIVIEW,
      'class': us.clsTBBUTTON + ' ' + us.idTBMULTIVIEW + '-4',
      'title': $t('change-tiling-pattern')
    }));

    var settingsButton = $('<a/>', {
      'id': us.TBSETTINGS,
      'class': us.clsTBBUTTON + ' ' + us.TBSETTINGS + '-e',
      'title': $t('settings-panel')
    });
    jtoolbar.append(settingsButton);

    $(us.idHashROOT).append(jtoolbar); // append the toolbar to the root node
    self.position();

    // Expose the ability to add a button externally
    self.addButton = function (button) {
      return $(button).insertBefore(settingsButton);
    };

    bindEvents_();
  };

  init_();
}

// -------------------------------------------------------------------------------------------------
//    ICON MANAGEMENT
// -------------------------------------------------------------------------------------------------
// ............................................ setIconState
//    setIconState - This function sets an icon to its active, enabled or disabled state
//            OR sets the muti-image icon to one of its 3 possible states.
//
//        Note that it depends upon the css class naming convention:
//            classRoot-e - defines icon for enabled state
//            classRoot-d - defines icon for disabled state
//            classRoot-a - defines icon for active state
//
export function setIconState (jContainer, classRoot, state) {
  if (state == 'active') { // most toolbar icon states
    jContainer.addClass(classRoot + '-a').removeClass(classRoot + '-e').removeClass(classRoot + '-d');
  } else if (state == 'enabled') {
    jContainer.addClass(classRoot + '-e').removeClass(classRoot + '-a').removeClass(classRoot + '-d');
  } else if (state == 'disabled') {
    jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-e').removeClass(classRoot + '-a');
  } else if (state == 't') { // multi image icon states
    jContainer.addClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-h').removeClass(classRoot + '-d');
  } else if (state == 'v') {
    jContainer.addClass(classRoot + '-v').removeClass(classRoot + '-4').removeClass(classRoot + '-h').removeClass(classRoot + '-d');
  } else if (state == 'h') {
    jContainer.addClass(classRoot + '-h').removeClass(classRoot + '-4').removeClass(classRoot + '-v').removeClass(classRoot + '-d');
  } else if (state == 'd' || state == '1' || state == '4') {
    jContainer.addClass(classRoot + '-d').removeClass(classRoot + '-h').removeClass(classRoot + '-v').removeClass(classRoot + '-4');
  } else {
    // Do nothing
  }
}

// -------------------------------------------------------------------------------------------------
//    DIALOG HELPER METHODS
// -------------------------------------------------------------------------------------------------

// ............................................ genericMessage
//    genericMessage - A general purpose message panel that removes itself from the DOM when closed.
//
//    parameters:
//        message:        required, string, your message to the user
//        title:            optional, string, default "Notice"
//
export function genericMessage (message = '', title = 'Notice') {
  const $t = translate.scope(i18Namespace);

  var jPanel = $('<div id=' + us.idMSGPANEL + ' title="' + title + '">' + message + '</div>');

  $(jPanel).dialog({
    autoOpen: true,
    modal: true,
    closeOnEscape: false,
    resizable: false,
    dialogClass: 'uscope-dialog dialogMover',
    close: function (event, ui) {
      $(this).remove();
    },
    buttons: [{
      text: $t('ok'),
      click: function () {
        $(this).remove();
      }
    }]
  });

  // append this modal dialog to body to work around a jquery issue that modal dialogs cannot be dismissed in popup mode
  //    (would normally want it appended to the uscope div)
  // note that the dialog is the parent to the panel created
  jPanel.parent().css('zIndex', 9999).appendTo('body');
}



// WEBPACK FOOTER //
// ./src/uScope/js/toolbar.js